import { ExpertId } from '@packages/shared/core/experts/entities';
import { Chat } from '../entities';

export type ChatState = {
  entities: Record<ExpertId, Chat>;
  chatCount: number;
  sessions: Array<ExpertId>;
};

export const chatInitialState: ChatState = {
  entities: {},
  chatCount: 0,
  sessions: [],
};
